import { RootState } from "@src/store";
import { selectedExperience } from "@src/store/slices/experiences";
import { Experience } from "@src/store/slices/experiences/types";

export const isPriceTest = (state: RootState) => {
  const experience = selectedExperience(state);
  if (!experience) return false;

  return isExperiencePriceTest(experience)(state);
};

export const isExperiencePriceTest =
  (experience: Experience) => (_state: RootState) => {
    return (
      experience?.category === "experiment" && experience?.type === "pricing"
    );
  };
